var map = {
	"./": 9120,
	"./AddIcon": 6861,
	"./AddIcon.tsx": 6861,
	"./ArrowDown": 4580,
	"./ArrowDown.tsx": 4580,
	"./CircleIcon": 1665,
	"./CircleIcon.tsx": 1665,
	"./DocIcon": 9821,
	"./DocIcon.tsx": 9821,
	"./LogoutIcon": 7521,
	"./LogoutIcon.tsx": 7521,
	"./Notificetion": 9029,
	"./Notificetion.tsx": 9029,
	"./SearchIcon": 8743,
	"./SearchIcon.tsx": 8743,
	"./ShowMoreIcon": 9688,
	"./ShowMoreIcon.tsx": 9688,
	"./SlashCircleIcon": 3695,
	"./SlashCircleIcon.tsx": 3695,
	"./TickCircleIcon": 9600,
	"./TickCircleIcon.tsx": 9600,
	"./TickIcon": 5270,
	"./TickIcon.tsx": 5270,
	"./add-circle.svg": 4927,
	"./arrow-circle-down.svg": 6412,
	"./arrow-down.svg": 4746,
	"./arrow-left.svg": 1833,
	"./arrow-right.svg": 153,
	"./arrow-up.svg": 9689,
	"./arrow.svg": 5090,
	"./articles.svg": 5890,
	"./book.svg": 6004,
	"./calculator.svg": 1216,
	"./close-circle.svg": 8657,
	"./comment.svg": 5184,
	"./construction.svg": 6261,
	"./contactDetails.svg": 1230,
	"./dashboard.svg": 7553,
	"./document-download.svg": 6413,
	"./eye-slash.svg": 8408,
	"./eye.svg": 5564,
	"./faq.svg": 215,
	"./file.svg": 1779,
	"./index": 9120,
	"./index.tsx": 9120,
	"./logo.svg": 3190,
	"./logout.svg": 2990,
	"./notepad.svg": 68,
	"./notification.svg": 4703,
	"./open.svg": 5099,
	"./phone.svg": 9193,
	"./reply-email.svg": 5222,
	"./save-2.svg": 1080,
	"./search.svg": 9262,
	"./team.svg": 101,
	"./theme.svg": 8472,
	"./tick.svg": 2058,
	"./users.svg": 8874,
	"./warning.svg": 9800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;